// (앱) http://local.ringleplus.com:3000/ko/webview/materials > 카테고리 선택
import { QIcon_search_default } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import { useState } from 'react'
import { n_material_list } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useMaterialsStack } from '../../../pages/[lang]/webview/materials'
import CategoryListSection from '../../new-portal/lessons/materials/CategoryListSection'
import WebviewStackContainer from '../common/WebviewStackContainer'
const SearchIcon = () => {
  const handleClickSearch = () => {
    console.log('이동 검색 스크린 ')
  }
  return (
    <>
      <div
        className="absolute top-[0px] right-[0px] z-[10] flex cursor-pointer items-end pt-[13px] pr-[20px]"
        onClick={handleClickSearch}
      >
        <QIcon_search_default width={24} height={24} />
      </div>
    </>
  )
}

interface IMaterialCategory {
  params: {
    categoryId: string
  }
}
const MaterialsCategoryActivity: ActivityComponentType = ({ params }: IMaterialCategory) => {
  const { t } = useTranslation()
  const { useMaterialsFlow } = useMaterialsStack()
  const { pop } = useMaterialsFlow()
  const [selectedHashId, setSelectedHashId] = useState('All')

  return (
    <WebviewStackContainer
      height="52px"
      title={t(n_material_list.all.title)}
      onBack={pop}
      appendRight={() => <SearchIcon />}
    >
      <div className="mx-[16px]">
        <CategoryListSection
          categoryId={Number(params.categoryId)}
          setCategoryId={null}
          selectedHashId={selectedHashId}
          setSelectedHashId={setSelectedHashId}
          isList={true}
        />
      </div>
    </WebviewStackContainer>
  )
}

export default MaterialsCategoryActivity
